import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import { printerSignIn } from '../actions/auth';
import { IOS_APP_CLIENT, isIosAppClient } from '../util/appSignIn';

const parent = {
  lineHeight: '300px',
  height: '300px',
  textAlign: 'center',
};

const child = {
  lineHeight: '1.5',
  display: 'inline-block',
  verticalAlign: 'middle',
};

// Opens the printer client (Gibraltar or the Medsender iOS app) with a one-time sign-in token.
// The token comes from this request's own response, never from an earlier one kept in the store:
// tokens work once, and a failed request must not open `medsender://signInToken=undefined`.
//
// The Medsender iOS app opens this page with ?client=ios inside its sign-in sheet: there it
// speaks of the app rather than the desktop Printer Driver, and offers no way into the rest of
// the web app, which cannot finish the sign-in (App renders it without the header and nav too).
class PrinterSignIn extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, loading: false };
  }

  componentDidMount() {
    this.getSignInToken();
  }

  getSignInToken = async () => {
    const { printerSignIn: getToken, location } = this.props;
    this.setState({ failed: false, loading: true });

    // The server lets a portal-only organization sign in to the iOS app only, so the page says
    // which client opened it.
    const response = await getToken(isIosAppClient(location?.search) ? { client: IOS_APP_CLIENT } : {});
    const token = response && !response.error ? response.data?.token : null;

    if (!token) {
      this.setState({ failed: true, loading: false });
      return;
    }

    this.setState({ loading: false });
    window.open(`medsender://signInToken=${encodeURIComponent(token)}`, '_self');
  };

  render() {
    const { failed, loading } = this.state;
    const { location } = this.props;
    const iosApp = isIosAppClient(location?.search);

    let message = 'The Printer Driver should open automatically. If not, click below to open and sign in.';
    if (iosApp) message = 'Signing you in to the Medsender app. If the app does not open, tap the button below.';

    let buttonLabel = iosApp ? 'Open the Medsender App' : 'Sign In to Printer Driver';
    if (failed) buttonLabel = 'Try Again';

    return (
      <div style={parent}>
        <div style={child}>
          {failed ? (
            <p role="alert">
              We couldn&apos;t create a sign-in link. Check your connection and try again.
            </p>
          ) : (
            <p>{message}</p>
          )}
          <Button
            onClick={this.getSignInToken}
            loading={loading}
            style={{
              marginTop: '20px',
              marginBottom: '30px',
              background: 'rgb(163,237,255)',
              borderColor: 'rgb(163,237,255)',
            }}
          >
            {buttonLabel}
          </Button>
          {!iosApp && (
            <div>
              <Link to="/app" style={{ fontSize: '15px' }}>Back to Main Dashboard</Link>
            </div>
          )}
        </div>
      </div>
    );
  }
}

PrinterSignIn.propTypes = {
  printerSignIn: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

PrinterSignIn.defaultProps = {
  location: undefined,
};

export { PrinterSignIn };

export default connect(null, { printerSignIn })(PrinterSignIn);
